import {
  CREATE_CASE,
  CREATE_CASE_FAIL,
  CREATE_CASE_INFO_MODAL_CLOSE,
  CREATE_CASE_SUCCESS,
  UPDATE_CASE,
  UPDATE_CASE_FAIL,
  UPDATE_CASE_SUCCESS
} from '../../actions/cm/caseCreation';

export const initialState = {
  isLoading: false,
  hasError: false,
  showInfoModal: false,
  caseId: null,
  errorMessage: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case CREATE_CASE:
    case UPDATE_CASE:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: ''
      };
    case CREATE_CASE_SUCCESS:
    case UPDATE_CASE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        showInfoModal: true,
        caseId: payload.caseId
      };
    case CREATE_CASE_FAIL:
    case UPDATE_CASE_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case CREATE_CASE_INFO_MODAL_CLOSE:
      return {
        ...state,
        showInfoModal: false
      };
    default:
      return state;
  }
}
